/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_SmallInputs */

const en_onboarding_font_small = /** @type {(inputs: Onboarding_Font_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small`)
};

const es_onboarding_font_small = /** @type {(inputs: Onboarding_Font_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pequeño`)
};

/**
* | output |
* | --- |
* | "Small" |
*
* @param {Onboarding_Font_SmallInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_small = /** @type {((inputs?: Onboarding_Font_SmallInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_SmallInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_small(inputs)
	return en_onboarding_font_small(inputs)
});